import {filters, filtersHazid, selectedMatrix, process} from './state';

/**
 * Establecer un valor para la variable matrix.
 */
export function setMatrix(state, matrix) {
    state.matrix = matrix;
}

/**
 * Establecer un valor para la variable selected_matrix.
 */
export function setSelectedMatrix(state, selected_matrix) {

    state.processes_bow_tie = [];
    let processes_bow_tie = [];

    if (!!selected_matrix.processes) {
        selected_matrix.processes.map(p => {

            let process = JSON.parse(JSON.stringify(p));
            process.activities = [];

            p.rows = 0;

            p.activities.map(a => {
                let activity = JSON.parse(JSON.stringify(a));
                activity.categories = [];

                a.rows = 0;

                a.categories.map(c => {

                    let category = JSON.parse(JSON.stringify(c));
                    category.top_events = [];

                    p.rows += c.top_events.length;
                    a.rows += c.top_events.length;
                    c.rows = c.top_events.length;

                    c.top_events.map(t => {

                        let add = false;

                        t.assessment = {
                            danger: -1,
                            class: 'table-active',
                            text: 'EVALUAR'
                        };

                        t.assessment_two = {
                            danger: -1,
                            class: 'table-active',
                            text: 'SIN EVALUAR'
                        };

                        t.consequences.map(cn => {
                            if (cn.pivot.order === 2 && cn.danger > t.assessment_two.danger) {
                                t.assessment_two.danger = cn.danger;
                                switch (cn.danger) {
                                    case 0:
                                        t.assessment_two.class = 'table-success';
                                        t.assessment_two.text = 'BAJO';
                                        break;
                                    case 1:
                                        t.assessment_two.class = 'table-warning';
                                        t.assessment_two.text = 'MEDIO';
                                        break;
                                    case 2:
                                        t.assessment_two.class = 'table-danger';
                                        t.assessment_two.text = 'ALTO';
                                        break;
                                }
                            }
                        });

                        t.consequences.map(cn => {
                            if (cn.pivot.order === 1 && cn.danger > t.assessment.danger) {
                                t.assessment.danger = cn.danger;
                                switch (cn.danger) {
                                    case 0:
                                        t.assessment.class = 'table-success';
                                        t.assessment.text = 'BAJO';
                                        break;
                                    case 1:
                                        t.assessment.class = 'table-warning';
                                        t.assessment.text = 'MEDIO';
                                        break;
                                    case 2:
                                        t.assessment.class = 'table-danger';
                                        t.assessment.text = 'ALTO';

                                        if (add) {
                                            category.top_events.pop();
                                        }

                                        add = true;
                                        category.top_events.push(JSON.parse(JSON.stringify(t)));

                                        break;
                                }
                            }
                        });
                    });

                    if (!!category.top_events.length) {
                        activity.categories.push(category);
                    }
                });

                if (!!activity.categories.length) {
                    process.activities.push(activity);
                }
            });

            if (!!process.activities.length) {
                processes_bow_tie.push(process);
            }
        });

        processes_bow_tie.map(p => {
            p.rows = 0;
            p.activities.map(a => {
                a.rows = 0;
                a.categories.map(c => {
                    c.rows = 0;
                    c.top_events.map(t => {
                        if (!t.danger_sources.length) {
                            state.danger_sources.map(ds => {
                                t.danger_sources.push({
                                    barriers: [],
                                    slq_hazard_identification_dangers_top_event_id: t.id,
                                    sys_source_danger_list_id: ds.id,
                                    description: '',
                                    danger_source: ds,
                                    first_order_barriers_ids: [],
                                    first_order_barriers: [],
                                    barriers_to_propose_ids: [],
                                    barriers_to_propose: []
                                });
                            });
                        }

                        p.rows += t.danger_sources.length;
                        a.rows += t.danger_sources.length;
                        c.rows += t.danger_sources.length;
                        t.rows = t.danger_sources.length;
                    });
                });
            });
        });
    }

    state.processes_bow_tie = processes_bow_tie;
    state.selected_matrix = selected_matrix;
}

/**
 * Establecer un valor para la variable companies.
 */
export function setCompanies(state, companies) {
    state.companies = companies;
}

/**
 * Establecer un valor para la variable companies_filter.
 */
export function setCompaniesFilter(state, companies_filter) {
    state.companies_filter = companies_filter;
}

/**
 * Establecer un valor para la variable locations.
 */
export function setLocations(state, locations) {
    state.locations = locations;
}

/**
 * Establecer un valor para la variable locations_filter.
 */
export function setLocationsFilter(state, locations_filter) {
    state.locations_filter = locations_filter;
}

/**
 * Establecer un valor para el atributo company_id de la variable filters.
 */
export function setCompanyIdFilter(state, company_id) {
    state.filters.company_id = company_id;
}

/**
 * Establecer un valor para el atributo slq_company_id de la variable selected_matrix.
 */
export function setCompanyIdSelectedMatrix(state, slq_company_id) {
    state.selected_matrix.slq_company_id = slq_company_id;
}

/**
 * Establecer un valor para el atributo location_id de la variable filters.
 */
export function setLocationIdFilter(state, location_id) {
    state.filters.location_id = location_id;
}

/**
 * Establecer un valor para el atributo slq_location_id de la variable selected_matrix.
 */
export function setLocationIdSelectedMatrix(state, slq_location_id) {
    state.selected_matrix.slq_location_id = slq_location_id;
}

/**
 * Establecer un valor para el atributo show de la variable modal.
 */
export function setModalShow(state, show) {
    state.modal.show = show;
}

/**
 * Restablecer el valor de la variable selected_matrix.
 */
export function resetSelectedMatrix(state) {
    state.selected_matrix = selectedMatrix();
}

/**
 * Establecer un valor para la variable action_hazid.
 */
export function setActionHazid(state, action_hazid) {
    state.action_hazid = action_hazid;
}

/**
 * Establecer un valor para el atributo show de la variable modal_hazid.
 */
export function setModalShowHazid(state, show) {
    state.modal_hazid.show = show;
}


/**
 * Establecer un valor para el atributo show de la variable modal_bow_tie.
 */
export function setModalShowBowTie(state, show) {
    state.modal_bow_tie.show = show;
}

/**
 * Establecer un valor para la variable action.
 */
export function setAction(state, action) {
    state.action = action;
}

/**
 * Establecer un valor para la variable action.
 */
export function setClearData(state, clear_data) {
    state.clear_data = clear_data;
}

/**
 * Restablecer el valor del atributo page de la variable filters.
 */
export function resetPageFilters(state) {
    state.filters.page = 1;
}

/**
 * Restablecer el valor de la variable filters.
 */
export function resetFilters(state) {
    state.filters = filters();
    state.matrix = {data: []};
}

/**
 * Restablecer el valor de la variable filters_hazid.
 */
export function resetFiltersHazid(state) {
    state.filters_hazid = filtersHazid();
}

/**
 * Establecer un valor para la variable processes.
 */
export function setProcesses(state, processes) {
    state.processes = processes;
}

/**
 * Establecer un valor para la variable processes.
 */
export function setProcess(state, process) {

    let temp_process = {
        id: process.id,
        slq_company_id: process.slq_company_id,
        slq_hazard_identification_id: process.slq_hazard_identification_id,
        slq_company_process_id: process.slq_company_process_id,
        activities: [],
        activities_objects: []
    };

    process.activities.map(a => {

        let obj = {
            slq_company_activity_id: a.activity.id,
            categories_objects: [],
            categories: []
        };

        obj.activity = a.activity;

        a.categories.map(c => {
            let objc = {
                slq_company_sga_category_id: c.category.id,
                top_events_objects: [],
                top_events: []
            };

            objc.category = c.category;

            c.top_events.map(te => {

                let objt = {
                    sys_top_event_list_id: te.top_event.id
                };

                objc.top_events.push(te.top_event.id);
                objc.top_events_objects.push(objt);
            });

            obj.categories.push(c.category.id);
            obj.categories_objects.push(objc);
        });

        temp_process.activities.push(a.activity.id);
        temp_process.activities_objects.push(obj);
    });

    state.process = temp_process;
}

/**
 * Establecer un valor para la variable processes.
 */
export function resetStep(state) {
    state.steps.step = 0;
}

/**
 * Establecer un valor para la variable processes.
 */
export function resetProcess(state,) {
    state.process = process();
}

/**
 * Establecer un valor para la variable activities.
 */
export function setActivities(state, activities) {
    state.activities = activities;
}

/**
 * Establecer un valor para la variable categories.
 */
export function setCategories(state, categories) {
    state.categories = categories;
}

/**
 * Establecer un valor para la variable top_events.
 */
export function setTopEvents(state, top_events) {
    state.top_events = top_events;
}

/**
 * Establecer un valor para la variable danger_sources.
 */
export function setDangerSources(state, danger_sources) {
    state.danger_sources = danger_sources;
}

/**
 * Establecer un valor para el step show de la variable steps.
 */
export function setStepSteps(state, step) {
    state.steps.step = step;
}

/**
 * Establecer un valor para el atributo activities_objects show de la variable process.
 */
export function setActivitiesObjectsProcess(state) {

    if (state.clear_data) {
        let activities_objects = [];

        state.process.activities.map(a => {

            let obj = {
                slq_company_activity_id: a,
                categories_objects: [],
                categories: []
            };

            if (Number.isInteger(a)) {
                obj.activity = state.activities.find(ac => ac.id === a);
            } else {
                obj.activity = {
                    name: a
                };
            }

            activities_objects.push(obj);
        });

        state.process.activities_objects = activities_objects;
    }
}

/**
 * Establecer un valor para el atributo categories show de la variable process.
 */
export function setCategoriesActivitiesObjectsProcess(state) {

    if (state.clear_data) {
        state.process.activities_objects.map(a => {
            let categories_objects = [];

            a.categories.map(c => {
                let obj = {
                    slq_company_sga_category_id: c,
                    top_events_objects: [],
                    top_events: []
                };

                if (Number.isInteger(c)) {
                    obj.category = state.categories.find(cat => cat.id === c);
                } else {
                    obj.category = {
                        description: c
                    };
                }

                categories_objects.push(obj);
            });

            a.categories_objects = categories_objects;
        });
    }

}

/**
 * Establecer un valor para el atributo categories show de la variable process.
 */
export function setTopEventsCategoriesActivitiesObjectsProcess(state) {

    if (state.clear_data) {
        state.process.activities_objects.map(a => {

            a.categories_objects.map(c => {
                let top_events_objects = [];

                c.top_events.map(te => {

                    let obj = {
                        sys_top_event_list_id: te
                    };

                    top_events_objects.push(obj);
                });

                c.top_events_objects = top_events_objects;
            });

        });
    }
}

/**
 * Establecer un valor para la variable top_event.
 */
export function setTopEvent(state, top_event) {
    top_event.second_order_barriers_ids = [];
    top_event.second_order_barriers = [];
    top_event.third_order_barriers_ids = [];
    top_event.third_order_barriers = [];

    if (!top_event.danger_sources.length) {
        state.danger_sources.map(ds => {
            top_event.danger_sources.push({
                slq_hazard_identification_dangers_top_event_id: top_event.id,
                sys_source_danger_list_id: ds.id,
                description: '',
                danger_source: ds,
                first_order_barriers_ids: [],
                first_order_barriers: [],
                barriers_to_propose_ids: [],
                barriers_to_propose: []
            });
        });
    } else {
        top_event.danger_sources.map(ds => {
            ds.first_order_barriers_ids = [];
            ds.first_order_barriers = [];
            ds.barriers_to_propose_ids = [];
            ds.barriers_to_propose = [];

            ds.barriers.map(b => {
                if (b.order === 1) {
                    ds.first_order_barriers_ids.push(b.sys_barrier_list_id);
                    ds.first_order_barriers.push(b);
                } else if (b.order === 4) {
                    ds.barriers_to_propose_ids.push(b.sys_barrier_list_id);
                    ds.barriers_to_propose.push(b);
                }
            });
        });

        top_event.barriers.map(b => {
            if (b.order === 2) {
                top_event.second_order_barriers_ids.push(b.sys_barrier_list_id);
                top_event.second_order_barriers.push(b);
            } else if (b.order === 3) {
                top_event.third_order_barriers_ids.push(b.sys_barrier_list_id);
                top_event.third_order_barriers.push(b);
            }
        });
    }

    console.log(top_event);

    state.top_event = top_event;
}

/**
 * Establecer un valor para la variable barriers.
 */
export function setBarriers(state, barriers) {
    state.barriers = barriers;
}

